import * as React from 'react'
import { Box, Typography, Accordion } from 'cs-kevlar-react'
import {
  MigrationResult,
  MigrationContext,
  MigrationStageStatus,
  MigrationStage,
} from '../../../api'
import {
  AgencyMigrationPlan,
  UserMigrationPlan,
  DeviceMigrationPlan,
} from './plans'
import { MigrationSummary } from './MigrationSummary'
import { MigrationError } from './MigrationError'
import {
  makeStyles,
  createStyles,
  Theme,
} from 'cs-kevlar-react/lib/es/theming/theme'

interface MigrationPlanProps {
  result: MigrationResult
  context: MigrationContext
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& ul': {
        margin: 0,
        padding: 0,
        paddingLeft: theme.spacing(8),
      },
    },
  }),
)

export const MigrationPlan: React.FunctionComponent<MigrationPlanProps> = ({
  result,
  context,
}) => {
  const classes = useStyles({})

  if (context === null || result === null) return null

  const hasCompletedMigration =
    context.stage === MigrationStage.LicenseMigration &&
    context.stageStatus === MigrationStageStatus.Complete
  const title = hasCompletedMigration
    ? `Migration Results: ${new Date(context.updatedOn).toLocaleString(
        'en-US',
        { timeZone: 'UTC' },
      )} UTC`
    : 'Migration Plan'

  return (
    <React.Fragment>
      <Accordion title={title} id="MigrationPlan" initiallyExpanded>
        <Box className={classes.root}>
          <ul>
            <li>
              <MigrationSummary result={result} />
            </li>
            {result.agencyLicenseEvents.hasEvents && (
              <li>
                <AgencyMigrationPlan
                  agencyLicenseEvents={result.agencyLicenseEvents}
                />
              </li>
            )}
            {result.userLicenseEvents.hasEvents && (
              <li>
                <UserMigrationPlan
                  userLicenseEvents={result.userLicenseEvents}
                />
              </li>
            )}
            {result.deviceLicenseEvents.hasEvents && (
              <li>
                <DeviceMigrationPlan
                  deviceLicenseEvents={result.deviceLicenseEvents}
                />
              </li>
            )}
          </ul>
        </Box>
      </Accordion>

      <MigrationError context={context} result={result} />
    </React.Fragment>
  )
}
